export const SET_GOLDLOCKED          = 'SET_GOLDLOCKED';
export const SET_GOLDLOCKEDREASON    = 'SET_GOLDLOCKEDREASON';